import React, { PureComponent, RefObject } from 'react'
import { IoIosArrowRoundBack } from 'react-icons/io';
import { GrUpdate } from 'react-icons/gr';
import { MdDoneAll, MdDelete } from 'react-icons/md';
import { AiOutlineUndo, AiOutlineEdit } from 'react-icons/ai';
import { connect } from 'react-redux';
import { completeTodo, deleteTodo, inittodoFB, updateTodo } from '../redux/actions';
// import { deleteTodo  } from '../redux/actions';

// type inittodo = {
//     createdAt: string,
//     title: string,  desc: string,  todoId: number,    
//     userId: number,    completed: string,   tags: string
// }
interface Props {
    todo: inittodoFB,  
    // todo: inittodo,
    uem: string,    
    deleteTodo: Function, 
    completeTodo: Function, 
    updateTodo: Function,
}

interface State {
    descP2: boolean
}

class TodoItem extends PureComponent<Props, State> {

    doneRef: RefObject<HTMLButtonElement>;
    undoRef: React.RefObject<HTMLButtonElement>;
    dltRef: React.RefObject<HTMLDivElement>;
    btnEdit: React.RefObject<HTMLButtonElement>;
    btnEditFinish: React.RefObject<HTMLButtonElement>;
    titleP: React.RefObject<HTMLParagraphElement>;
    descP: React.RefObject<HTMLParagraphElement>;
    titleI: React.RefObject<HTMLInputElement>;
    descI: React.RefObject<HTMLTextAreaElement>;
    
    constructor(props: Props, state: State){
        super(props);
        this.doneRef = React.createRef<HTMLButtonElement>();
        this.undoRef = React.createRef<HTMLButtonElement>();
        this.dltRef = React.createRef<HTMLDivElement>();
        this.titleP = React.createRef<HTMLParagraphElement>();
        this.titleI = React.createRef<HTMLInputElement>();
        this.descP = React.createRef<HTMLParagraphElement>();
        this.descI = React.createRef<HTMLTextAreaElement>();
        this.btnEdit = React.createRef<HTMLButtonElement>();
        this.btnEditFinish = React.createRef<HTMLButtonElement>();

        state = {
            descP2: false            
        }      

    }


    handelCancel = (e: any) => {
        if (
            e.target.parentElement.classList.contains('btnCancel') ||
            e.target.parentElement.parentElement.classList.contains('btnCancel')
        ){
            this.dltRef.current!.style.display = 'none';  
        }
    }

    handelComplete = (e: any, uem: string) => {
        const btn1 = this.doneRef.current!;
        const btn2 = this.undoRef.current!;
        if (
            e.target.parentElement.classList.contains('btnComplete') ||
            e.target.parentElement.parentElement.classList.contains('btnComplete')
        ){
            btn1.style.display = 'none'; btn2.style.display = 'block';
            // this.doneRef.current!.style.display = 'none';
            this.btnEdit.current!.style.opacity = '0.5';
            this.props.completeTodo(this.props.todo, true, this.props.uem);
        }else{                 
            btn1.style.display = 'block'; btn2.style.display = 'none'; 
            this.btnEdit.current!.style.opacity = '1';
            this.props.completeTodo(this.props.todo, false, this.props.uem);
        }
    }

    handelEdit = () => {
        this.titleI.current!.value = `${this.titleP.current!.textContent}`;
        this.descI.current!.value = `${this.descP.current!.textContent}`;
    }

    handelEditBtns = (e: any) => {
        console.log('clicked');
        if (
            e.target.parentElement.classList.contains('btnEdit') ||
            e.target.parentElement.parentElement.classList.contains('btnEdit')
        ){
            console.log( e.target , this.btnEdit.current , this.btnEditFinish.current );
            this.titleI.current!.style.height = `${this.titleP.current!.offsetHeight}`;
            this.btnEdit.current!.style.display = 'none';  
            this.btnEditFinish.current!.style.display = 'block' ;
            this.titleP.current!.style.display = 'none';   this.titleI.current!.style.display = 'block';
            this.descP.current!.style.display = 'none';    this.descI.current!.style.display = 'block';                
        }else{                         
            console.log( e.target , this.btnEdit.current , this.btnEditFinish.current );
            this.btnEdit.current!.style.display = 'block';  
            this.btnEditFinish.current!.style.display = 'none' ; 
            this.titleP.current!.style.display = 'block';   this.titleI.current!.style.display = 'none';
            this.descP.current!.style.display = 'block';    this.descI.current!.style.display = 'none';
        }
    }

    handleMoreDescription = () => {
        this.setState({ descP2: true })
    }

    handleLessDescription = () => {
        this.setState({ descP2: false })
    }


    render() {
        const { todo, uem, deleteTodo, completeTodo, updateTodo } = this.props;
        return (
            <div className='todo-list__item'>
                <p className={`${ (todo.completed === 'false') ? 'todoTU' : 'todoTD' }`} ref={this.titleP} >{todo.title}</p>
                {
                    todo.desc.length <= 272
                    ? <p className={`${ (todo.completed === 'false') ? 'todoDU' : 'todoDD' }`} ref={this.descP} >{todo.desc}</p>
                    : <p className={`${ (todo.completed === 'false') ? 'todoDU' : 'todoDD' }`} ref={this.descP} >                        
                        {todo.desc.slice(0, 272)}
                        {this.state?.descP2 == true ? todo.desc.slice(272) : ''}
                        <span className='todoDMoreLess' onClick={() => {
                            this.state?.descP2 == true ? this.handleLessDescription() : this.handleMoreDescription()
                        }}>                           
                            {this.state?.descP2 == true ? ' less' : ' ...more'}
                        </span>
                    </p>                                        
                }
                <input type="text" className='editInputs' ref={this.titleI} />
                <textarea className='editInputs' ref={this.descI} ></textarea>
    
                <div>
                    <div>
                    {
                        (todo.tags) && todo.tags.split(' ').map( (tag, i) => {  return(
                            (i < 3) &&  <span key={i}>{tag}</span>  
                        ) } )
                    }</div>
                    <p>{todo.createdAt}</p>
                </div>
    
                <div className='todo-list__item__controlls'>
                    {   (todo.completed === 'false') 
                        ? <button className='btnEdit' style={{ opacity: '1' }} ref={this.btnEdit}>   <AiOutlineEdit onClick={(e) => { this.handelEditBtns(e); this.handelEdit();} } />    </button>
                        : <button className='btnEdit' style={{ opacity: '0.5' }} ref={this.btnEdit}>   <AiOutlineEdit />   </button>
                    }
                    <button className='btnEditFinish' ref={this.btnEditFinish}>
                        <GrUpdate onClick={(e) => { this.props.updateTodo(todo, this.titleI.current!.value, this.descI.current!.value, uem); this.handelEditBtns(e); } } />
                    </button>                
                    
                    <button className={`btnComplete ${ ( todo.completed === 'true' ) && `btnCompleteToggle` }`} ref={this.doneRef}> 
                        <MdDoneAll onClick={(e) => this.handelComplete(e, uem)} /> 
                    </button>
                    <button className={`btnUndo ${ ( todo.completed === 'false' ) && `btnCompleteToggle` }`} ref={this.undoRef}> 
                        <AiOutlineUndo  onClick={(e) => this.handelComplete(e, uem)} /> 
                    </button>
    
                    <button className='btnDelete'> <MdDelete onClick={() => {this.dltRef.current!.style.display = 'block'} } /> </button>
                </div>
    
                <div className="dltHandel" ref={this.dltRef}>
                        <p>Are you sure to delete todo</p>                    
                        <button className='btnCancel'> <IoIosArrowRoundBack onClick={ (e) => this.handelCancel(e) }/> </button>
                        <button className='btnDelete btnCancel'> <MdDelete onClick={ (e) => { this.props.deleteTodo( todo, uem ); this.handelCancel(e); } }/> </button>
                </div>
            </div>
        )
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return{
        deleteTodo : (todoItem: inittodoFB, uem: string) => dispatch(deleteTodo(todoItem, uem)),
        // deleteTodo : (todoItem: object, uem: string) => dispatch(deleteTodo(todoItem, uem)),
        completeTodo : (todoItem: inittodoFB, checked: boolean, uem: string) => dispatch(completeTodo(todoItem, checked, uem)),
        updateTodo : (todoItem: inittodoFB, val1: string, val2: string, uem: string) => dispatch(updateTodo(todoItem, val1, val2, uem))
    }
}

export default connect( null, mapDispatchToProps )( TodoItem )